// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButton_container__2nFrn","icon":"BackButton_icon__1RiN5","text":"BackButton_text__2mEHQ","hover":"BackButton_hover__hAfh_"};